<footer
  class="footer container gap-y-0 text-vtmn-play-content-inverse bg-vtmn-play-content-brand pt-3 lg:gap-y-3"
>
  <div class="col-span-12 flex flex-col py-4 break-words lg:col-span-2">
    <p
      *ngIf="title"
      class="break-normal font-condensed font-medium self-start mb-4 hidden"
    >
      {{ title }}
    </p>

    <app-logo [name]="logo" height="25"></app-logo>

    <div
      *ngIf="description"
      class="footer__info-block__description break-normal mt-3 font-condensed text-sm"
      [innerHtml]="description | safeHtml"
    ></div>
  </div>

  <app-collapse
    *ngFor="let column of columns; let isFirst = first"
    class="col-span-12 py-3 lg:col-span-2"
    [class.lg:col-start-4]="isFirst"
    [title]="column?.title"
    [isCart]="false"
    [isFooter]="true"
    [isOpen]="isCollapsesOpen"
    [disabled]="isCollapsesDisabled"
    [iconName]="collapsesIcon"
    buttonExtraClass="justify-between font-condensed font-medium cursor-default"
  >
    <ul class="text-sm">
      <li *ngFor="let link of column?.links" class="mt-3">
        <a
          class="hover:underline"
          [href]="link.link"
          [target]="link.target"
          [rel]="'noopener noreferrer'"
        >
          {{ link.title }}
        </a>
      </li>
    </ul>
  </app-collapse>

  <div
    class="col-span-12 text-center lg:col-start-10 lg:col-span-3 lg:text-right"
  >
    <div *ngIf="buttonsConfig?.length" class="py-4">
      <p class="font-condensed font-medium mb-2">
        {{ 'attendee.footer.column.social_networks.title' | translate }}
      </p>

      <app-social-buttons
        class="inline-flex"
        [buttonsConfig]="buttonsConfig"
        [variant]="socialButtonVariant"
      ></app-social-buttons>
    </div>

    <div class="py-2">
      <label for="language-select" class="sr-only">
        {{ 'attendee.footer.language.label' | translate }}
      </label>

      <select
        id="language-select"
        class="bg-transparent font-bold font-condensed py-2"
        [formControl]="language"
        (change)="onLanguageChange()"
      >
        <option *ngFor="let language of languages" [ngValue]="language.value">
          {{ language.label }}
        </option>
      </select>
    </div>
  </div>

  <div
    class="col-span-12 py-4 flex flex-col items-center lg:flex-row lg:justify-center lg:items-end lg:pt-4 lg:pb-6"
  >
    <app-logo [name]="logoTypeEnum.Light" [height]="25"></app-logo>

    <p class="mt-2 text-sm lg:mt-0 lg:ml-3">
      {{ 'attendee.footer.copyright' | translate }}
    </p>
  </div>
</footer>
